import Layout from "../../containers/Layout";
import BoxInfoTemplate from "../BoxInfoTEmplate/BoxInfoTemplate";
import Seo from "../Seo/Seo";

const Support = () => {
  return (
    <Layout mt={16}>
      <Seo
        title="Support & Contact"
        description="Need help with your Spanish lessons or materials? Get in touch — we usually respond within 24 hours, Monday to Friday."
        path="/support"
      />
      <BoxInfoTemplate
        title=""
        subTitle="Support & Contact"
        mainText="Need help with your lessons or materials? We're here for you!"
        iconType="info"
        showQuotes={false}
        showShadow={true}
        borderColor="blue"
      />

      <div
        className="support-container"
        style={{ textAlign: "left", padding: "1rem 0" }}
      >
        <h2 style={{ marginBottom: "1rem" }}>1. Contact Information</h2>
        <p style={{ marginBottom: "1rem" }}>
          If you have questions about your lessons, billing, or technical
          issues, you can reach out via email, join the newsletter and reply to
          it.
        </p>

        <h2 style={{ marginBottom: "1rem" }}>2. Response Time</h2>
        <p style={{ marginBottom: "1rem" }}>
          We usually respond within 24 hours, Monday to Friday. If you're
          contacting us over the weekend or during a holiday period, please
          allow more time.
        </p>

        <h2 style={{ marginBottom: "1rem" }}>3. Common Issues</h2>
        <ul style={{ marginBottom: "1rem" }}>
          <li>
            Can't access materials? Double-check your email inbox or spam
            folder.
          </li>
          <li>
            Need to reschedule a class? You can do so up to 24h in advance via
            your booking confirmation email.
          </li>
          <li>
            Payment issues? Please include your payment reference when writing
            to us.
          </li>
        </ul>

        <h2 style={{ marginBottom: "1rem" }}>4. Suggestions Welcome!</h2>
        <p style={{ marginBottom: "1rem" }}>
          This is a small and evolving project. If you have ideas or feedback to
          make Spanish with Alex better, we’d love to hear them!
        </p>

        <p className="signature" style={{ marginTop: "1rem" }}>
          Thanks for being part of the community. 😊
        </p>
      </div>
    </Layout>
  );
};

export default Support;
